import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=0da46a9e&scoped=true&"
import script from "./MainHeader.vue?vue&type=script&lang=js&"
export * from "./MainHeader.vue?vue&type=script&lang=js&"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=0da46a9e&scoped=true&lang=scss&"
import style1 from "./MainHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da46a9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2141801166/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0da46a9e')) {
      api.createRecord('0da46a9e', component.options)
    } else {
      api.reload('0da46a9e', component.options)
    }
    module.hot.accept("./MainHeader.vue?vue&type=template&id=0da46a9e&scoped=true&", function () {
      api.rerender('0da46a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/containers/core/header/MainHeader.vue"
export default component.exports